/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */

// Run 'npm run extract-intl' then 'npm run compile-intl' to generate the compiled-lang file
const typescriptTranslationMessages = require("../compiled-lang/en.json");
const enTranslationMessages = require("./translations/en.json");
const esTranslationMessages = require("./translations/es.json");
const frTranslationMessages = require("./translations/fr.json");

const combinedEnMessages = Object.assign(
  enTranslationMessages,
  typescriptTranslationMessages,
);

export const DEFAULT_LOCALE = "en";

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, combinedEnMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

export const translationMessages = {
  en: formatTranslationMessages("en", combinedEnMessages),
  es: formatTranslationMessages("es", esTranslationMessages),
  fr: formatTranslationMessages("fr", frTranslationMessages),
};
